<div id="recomendacao" class="panel panel-default-agro1 pointer" ng-click="openClosePanel()" disabled="true" ng-show="!!aplicacao.recommendation">
  <div class="panel-heading panel-heading-list">
    <h3 class="text-center">Recomendação</h3>
  </div>
  <div class="panel-body" ng-show="showPanel">
    <h5 class="text-cinza">
      {{::aplicacao.recommendation.grupo_insumos | orderBy:'descricao' | getTextItems | capitalize}}
    </h5>

    <p>
      <span ng-show="aplicacao.tipoOperacao !== 'operacao_semeadura'">
        Período: <strong>
          <span ng-class="{'text-danger': aplicacao.classificacao.dtIni}">{{::aplicacao.recommendation.data_inicio | date:'dd/MM/yy'}}</span>
           a
           <span ng-class="{'text-danger': aplicacao.classificacao.dtFim}"> {{::aplicacao.recommendation.data_termino | date:'dd/MM/yy'}}</span>
         </strong>
        <br>
      </span>
      <span ng-if="aplicacao.tipoOperacao === 'operacao_semeadura'">
        Período: <strong>{{::getRecommendationDataInicio(aplicacao) | date:'dd/MM/yy'}} a {{::getRecommendationDataFim(aplicacao) | date:'dd/MM/yy'}}</strong>
        <br>
      </span>
      Recomendante: <strong>{{::(aplicacao.recommendation.recomendante || aplicacao.recommendation.usuario).nome_completo | capitalize}}</strong>
      <br>
      Área: <strong ng-class="{'text-danger': aplicacao.classificacao.area}">{{::aplicacao.recommendation.gleba.area_recomendada | number:2}}ha</strong>
      <br>

      <span ng-show="aplicacao.recommendation.temperatura.minima">
        Temperatura acima de: <strong>{{::aplicacao.recommendation.temperatura.minima | number:0}}°C</strong>
        <br>
      </span>
      <span ng-show="aplicacao.recommendation.temperatura.maxima">
        Temperatura abaixo de: <strong ng-class="{'text-danger': aplicacao.classificacao.temperaturaFinal}">{{::aplicacao.recommendation.temperatura.maxima | number:0}}°C</strong>
        <br>
      </span>

      <span ng-show="aplicacao.recommendation.umidade.minima">
        Umidade acima de: <strong>{{::aplicacao.recommendation.umidade.minima | number:0}}%</strong>
        <br>
      </span>
      <span ng-show="aplicacao.recommendation.umidade.maxima">
        Umidade abaixo de: <strong ng-class="{'text-danger': application.classificacao.umidadeFinal}">{{::aplicacao.recommendation.umidade.maxima | number:0}}%</strong>
        <br>
      </span>

      <span ng-show="aplicacao.recommendation.vento.maxima">
        Velocidade do vento: <strong ng-class="{'text-danger': application.classificacao.velocidadeVento}">{{::aplicacao.recommendation.vento.maxima | number:1}}</strong>
        <br>
      </span>

      <span ng-show="aplicacao.recommendation.horas_sem_chuva">
        Horas sem Chuva: <strong ng-class="{'text-danger': application.classificacao.horasSemChuva}">{{::aplicacao.recommendation.horas_sem_chuva | number:0}}</strong>
        <br>
      </span>

      <span ng-show="aplicacao.recommendation.velocidade.minima">
        Velocidade mínima: <strong>{{::aplicacao.recommendation.velocidade.minima | number:0}} km/h</strong>
        <br>
      </span>
      <span ng-show="aplicacao.recommendation.velocidade.maxima">
        Velocidade máxima: <strong>{{::aplicacao.recommendation.velocidade.maxima | number:0}} km/h</strong>
        <br>
      </span>
      <span ng-show="aplicacao.recommendation.parametro.velocidade_minima">
        Velocidade mínima: <strong>{{::aplicacao.recommendation.parametro.velocidade_minima | number:0}} km/h</strong>
        <br>
      </span>
      <span ng-show="aplicacao.recommendation.parametro.velocidade_maxima">
        Velocidade máxima: <strong>{{::aplicacao.recommendation.parametro.velocidade_maxima | number:0}} km/h</strong>
        <br>
      </span>
      <span ng-show="aplicacao.recommendation.parametro.velocidade_maxima_vento">
        Velocidade vento: <strong>{{::aplicacao.recommendation.parametro.velocidade_maxima_vento | number:0}} km/h</strong>
        <br>
      </span>
    </p>

    <table class="table-card">
      <thead>
        <tr>
          <th>Produto</th>
          <th class="text-right">Dose</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="produto in aplicacao.recommendation.insumos track by $index" class="f-size-11"
            ng-class="{'text-danger': aplicacao.classificacao.insumosRecomendacao[$index].produto}">
          <td class="vertical-middle padding-bottom-5">
            {{produto.descricao || produto.produto.descricao}}
          </td>
          <td class="vertical-middle text-right padding-left-5 padding-bottom-5" ng-class="{'text-danger': aplicacao.classificacao.itensAplicacao[$index].dose}">
            {{(produto.dose || produto.qt_dose) | number:2}} {{::produto.unidade.abreviatura | lowercase}}/ha
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
